export enum SalesInd {
    NORMAL = 'S'
    , CONSIGNMENT = 'C'
    , FOC = 'F'
}


// WEBPACK FOOTER //
// ./src/enums/salesind.enum.ts